import { ThemeProvider, createTheme, responsiveFontSizes } from "@mui/material"
import {  useSelector } from "react-redux"
import {  useMemo } from "react"
import { getCustomTheme } from "../../helpers/ThemeHelper"

export default function AppThemeProvider(props) {
  const { children } = props
  const themeMode = useSelector(state => state.theme.themeMode)

  const theme = useMemo(
    () => responsiveFontSizes(createTheme(getCustomTheme(themeMode))),
    [themeMode]
  )

  return (
    <ThemeProvider theme={theme}>
      {children}
    </ThemeProvider>
  )
}
